module.exports = __webpack_public_path__ + "media/2.b3af21ea.mp3";